module.exports = __webpack_public_path__ + "img/CloudyAndOnceRain.b63ac5d9.png";